export default "__VITE_ASSET__Dqda56qm__"